import { useEffect, useState } from 'react';

interface ElementsToUpdate {
    [tag: string]: { property: string; value: string }[];
}

/**
 * React helmet only handles elements inside the head tag that contain data-react-helmet="true"
 */
const useDocumentHeadIsPreparedForReactHelmet = (elementsToUpdateByTag: ElementsToUpdate) => {
    const [readyForReactHelmet, setReadyForReactHelmet] = useState(false);

    const stringifiedElements = JSON.stringify(elementsToUpdateByTag);

    useEffect(() => {
        const parsedElementsToUpdateByTag = JSON.parse(stringifiedElements) as ElementsToUpdate;
        if (parsedElementsToUpdateByTag) {
            const childrenOfHead = Array.from(document.getElementsByTagName('head')[0].children);

            childrenOfHead.forEach((child) => {
                const tagName = child?.tagName?.toLowerCase();

                parsedElementsToUpdateByTag[tagName]?.forEach((tagEl) => {
                    if (child.getAttribute(tagEl.property) === tagEl.value) {
                        child.setAttribute('data-rh', 'true');
                    }
                });
            });

            setReadyForReactHelmet(true);
        }
    }, [stringifiedElements]);

    return readyForReactHelmet;
};

export default useDocumentHeadIsPreparedForReactHelmet;
